
import Health from './components/Health';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import HomeVisitTask from './components/HomeVisitTask';
import FindHelpDashboard from './components/FindHelpDashboard';
import UserTaskChart from './components/Task/UserTaskChart';
import MemberTaskDetails from './components/MemberTaskDetails';
import FindHelpChart from './components/FindHelp/FindHelpChart';
import IdCard from './components/IdCard/IdcardDetails';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
// import { useMsal } from '@azure/msal-react';
// import { loginRequest } from './authConfig';


function App() {
  // const { instance, accounts } = useMsal();
  // const [token, setToken] = useState(null);

  // useEffect(() => {
  //   if (accounts && accounts.length > 0) {
  //     instance.acquireTokenSilent({ ...loginRequest, account: accounts[0] })
  //       .then(response => {
  //         setToken(response.accessToken);
  //         console.log('Azure Token:', response.accessToken);
  //       })
  //       .catch(e => {
  //         console.error('Token acquisition failed:', e);
  //       });
  //   } else {
  //     // Automatically initiate login if not signed in
  //     instance.loginRedirect(loginRequest);
  //   }
  // }, [instance, accounts]);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/CustomCards/findhelp" />} />
          <Route path="/CustomCards" element={<Home />} />
          <Route path="/CustomCards/homevisittask" element={<HomeVisitTask />} />
          <Route path="/CustomCards/findhelp" element={<FindHelpDashboard />} />
          <Route path="/task/user-chart" element={<UserTaskChart />} />
          <Route path="/task/member-details" element={<MemberTaskDetails />} />
          <Route path="/findhelp/chart" element={<FindHelpChart />} />
          <Route path="/ui/health" element={<Health />} />
          <Route path="/idcard/idcarddetails" element={<IdCard />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
